import type { AvailableSitesResponse } from '@atlassiansox/cross-flow-plugins';
import { getApiGatewayUrl } from '@trello/api-gateway';
import { Analytics } from '@trello/atlassian-analytics';
import { clientVersion } from '@trello/config';

export const getSwitcherAvailableProductsUrl = () =>
  getApiGatewayUrl('/available-products/api/available-products');

export const getAvailableSites = async (): Promise<AvailableSitesResponse> => {
  const url = getSwitcherAvailableProductsUrl();
  try {
    const response = await fetch(url, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'X-Trello-Client-Version': clientVersion,
      },
    });

    if (response.ok) {
      return response.json();
    }

    throw new Error('unauthorized');
  } catch (error) {
    Analytics.sendOperationalEvent({
      action: 'errored',
      actionSubject: 'fetchAvailableSites',
      source: 'crossFlowEssentials',
    });
    return { sites: [] };
  }
};
